import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {NumNotRoundPipe} from 'src/app/shared/pipes/common.pipe';
import {IBService} from '../ib.service';
import {ExcelExportService} from 'src/app/components/cms/excel.export.service';
import { AppService } from 'src/app/app.service';
import { Constants } from 'src/app/shared/utils/constants';
declare var $: any;

@Component({
  selector: 'rox-export-auto',
  templateUrl: './export-auto.component.html',
  styleUrls: ['./export-auto.component.sass']
})
export class ExportAutoComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() totalRecord;
  @Input() pageSize;
  @Input() condition;
  autoExport: any = {
    totalStep: 0,
    step: 0,
    progress: 0
  };
  listIBExport = [];
  countries = [];
  subscriptions: any = {
    getExport: new Subscription(),
    export: new Subscription(),
  };
  enableExport = false;
  constructor(
    private service: IBService,
    private decimal: NumNotRoundPipe,
    private exportService: ExcelExportService,
    private appService: AppService
  ) {
    this.countries = Constants.COUNTRIES.map((c) => {
      return {label: c.name, value: c.code};
    });
    this.enableExport = this.appService.buildPermissionExport();
  }

  ngOnInit(): void {
  }

  getDataExport(pageIndex): void {
    this.subscriptions.getExport = this.service
      .getAffiliates({
        q: this.condition.keyword
          ? encodeURIComponent(this.condition.keyword.trim())
          : this.condition.keyword.trim(),
        page: pageIndex,
        page_size: this.pageSize
      })
      .subscribe((data) => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          // use for auto export
          this.handleGetExportData(data.data);
        }
      });
  }

  onAutoExport(): void {
    this.listIBExport = [];
    this.autoExport.totalStep = Math.ceil(this.totalRecord / this.pageSize);
    this.autoExport.step = 1;
    this.autoExport.progress = 0;
    this.getDataExport(1);
  }

  handleGetExportData(exports): void {
    if (exports.length > 0) {
      this.autoExport.progress = (100 / this.autoExport.totalStep) * this.autoExport.step;
      setTimeout(() => {
        this.listIBExport = [...this.listIBExport, ...exports];
        if (this.autoExport.step < this.autoExport.totalStep) {
          this.autoExport.step += 1;
          this.getDataExport(this.autoExport.step);
        } else {
          this.exportProcess(this.listIBExport);
          this.resetAutoExport();
        }
      }, 200);
    }
  }

  formatNumber(val): number{
    val = val.replaceAll(',','')
    return Number(val)
  }

  exportProcess(exports): void {
    const customers = [];
    exports.forEach(value => {
        const obj = {
          ID: value.userId,
          Username: value.getUsername(),
          'Username (JP)': value.getUsernameJP(),
          Email: value.email,
          'KYC Status': value.getTextKYC(),
          Level: value.level,
          'Total User': value.totalUser,
          'Total Lot': value.userData.totalLot,
          'Currency':  value.currency?value.currency.toUpperCase():'',
          'Total Lot Rebate ': this.formatNumber(this.decimal.transform(value.userData.affiliateReturn, '1.2-2')),
          'Total Deposit':  this.formatNumber(this.decimal.transform(value.userData.deposit,'1.2-2')),
          'Total Credit': this.formatNumber(this.decimal.transform(value.userData.credit, '1.2-2')),
          'Total IB': value.ibData.totalIb,
          'Total Sub IB Com': this.formatNumber(this.decimal.transform(value.ibData.affiliateReturn, '1.2-2')),
          'Earning': this.formatNumber(this.decimal.transform(value.totalEarning.affiliateReturn, '1.2-2')),
        };
        customers.push(obj);
      }
    );
    const fileName = 'ib_list_auto';
    const headers = [
      {
        'ID': '',
        'Username': '',
        'Username (JP)': '',
        'Email': '',
        'KYC Status': '',
        'Level': '',
        'Total User': '',
        'Total Lot': '',
        'Currency':'',
        'Total Lot Rebate ': 'User',
        'Total Deposit': '',
        'Total Credit': '',
        'Total IB': '',
        'Total Sub IB Com': 'Ib',
        'Earning': ''
      }
    ]
    this.exportService.exportExcel(customers, fileName);
    // exportToCsv(customers, fileName, []);
  }

  resetAutoExport(): void {
    this.autoExport = {
      totalStep: 0,
      step: 0,
    };
    this.listIBExport = [];
    setTimeout(() => {
      $('#modalLoadingExport .close').trigger('click');
    }, 200);
  }

  ngAfterViewInit(): void {
    $('#modalLoadingExport').on('hide.bs.modal', () => {
      this.resetAutoExport();
    });
  }

  ngOnDestroy(): void {
    for (const key in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(key) && this.subscriptions[key]) {
        this.subscriptions[key].unsubscribe();
      }
    }
  }

}
